export const setOverlayOnDocument = (target) => {
  const documentOverlay = document.querySelector('.documentOverlay')
  if (documentOverlay) {
    documentOverlay.classList.add('documentOverlay-active')
  }
  const targetElement = document.querySelector(target)
  if (targetElement) {
    targetElement.classList.add('documentOverlayElement-focus')
  }
}
